import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { AuthenticationService } from '../service/auth.service';
import { UserService } from '../service/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DesignService } from '../service/design.service';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit {

  passwordForm: FormGroup
  submitted: boolean = false
  invalidLogin: boolean = false
  returnUrl: string = ""
  showPassword: boolean = false;

  constructor(
    private formBuilder: FormBuilder, 
    private router: Router, 
    private route: ActivatedRoute,
    private userService: UserService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private designService: DesignService) { }

  get form() { return this.passwordForm.controls; }

  get logoUrl(): string {
    return this.designService.getLogoUrl()
  }

  ngOnInit() {
    this.spinner.hide();

    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, this.strongPasswordValidator]]
    });

    this.route.queryParams
      .subscribe(params => this.returnUrl = params['return'] || 'dashboard');
  }

  strongPasswordValidator(control: FormControl): ValidationErrors | null {
    const strongPasswordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-*#$%@]).{8,}$');
    return strongPasswordRegex.test(control.value) ? null : { 'weakPassword': true };
  }

  getUserName(): string {
    let user = this.authService.getUser()

    if(user) {
      return user.name
    }
  }

  onSubmit() {
    this.submitted = true
    this.invalidLogin = false

    if (this.passwordForm.invalid) {
      swal.fire('Atenção', 'A senha não atende aos requisitos mínimos de segurança.', 'error')
      return;
    }

    this.spinner.show();

    this.userService.changePassword(this.form.password.value)
      .subscribe(() => {
        this.router.navigateByUrl(this.returnUrl)
      },
      () => {
        this.spinner.hide();
        this.invalidLogin = true;
      });
  }

  formHasErrors() {
    return this.passwordForm.invalid
  }
 
  passwordHasErrors() {
    return this.form.password.errors && this.form.password.errors.required
  }

  isLengthValid(password: string): boolean {
    return password.length >= 8;
  }

  hasUpperCase(password: string): boolean {
    return /[A-Z]/.test(password);
  }

  hasLowerCase(password: string): boolean {
    return /[a-z]/.test(password);
  }

  hasNumber(password: string): boolean {
    return /[0-9]/.test(password);
  }

  hasSpecialChar(password: string): boolean {
    return /[\*\-#$%@]/.test(password);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
